import React, { useRef } from "react";
import { motion } from "framer-motion";

const MagneticButton = React.forwardRef(function MagneticButton(
  {
    children,
    className = "",
    strength = 18,
    onClick,
    "data-testid": testId,
    as = "button",
    href,
    ariaLabel,
    ...props
  },
  forwardedRef
) {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    el.style.setProperty("--mx", `${x}px`);
    el.style.setProperty("--my", `${y}px`);
    const relX = (x - rect.width / 2) / rect.width;
    const relY = (y - rect.height / 2) / rect.height;
    el.style.transform = `translate(${relX * strength}px, ${relY * strength}px)`;
  };
  const handleLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "translate(0,0)";
  };

  const setRefs = (node) => {
    ref.current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  const Tag = as;
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.97 }}
      className="inline-block"
    >
      <Tag
        ref={setRefs}
        href={href}
        target={as === "a" ? "_blank" : undefined}
        rel={as === "a" ? "noopener noreferrer" : undefined}
        onClick={onClick}
        onMouseMove={handleMove}
        onMouseLeave={handleLeave}
        aria-label={ariaLabel}
        data-testid={testId}
        className={`magnetic-btn inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${className}`}
        {...props}
      >
        {children}
      </Tag>
    </motion.div>
  );
});

export default MagneticButton;
